import React from 'react'
import Button from '../../components/buttons/buttons.component'
import styled from 'styled-components'
import Gallery from './components/gallery.component'
import Container from './../../components/layout/container.component'
import PaymentInfo from './components/payment-info.component'
import AccordionSecondary from '../../components/accordion/accordion-secondary.component'
import StyledFlexContainer from './../../components/containers/flex-container.component'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { clientActions } from '../../actions/client.actions'
import { bindActionCreators } from 'redux'
import { StoreProductService } from './../../services/store-product.service'
import * as config from 'config'

const baseUrl = `${config.contentUrl}loja/produto/`

const StyledButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
`

const StyledDescription = styled.p`
	white-space: pre-wrap;
`

class StoreProductDetailPage extends React.Component {
	constructor(props) {
		super(props)
		this.getAccordionItems = getAccordionItems.bind(this)
		this.goToPointsExchange = goToPointsExchange.bind(this)

		this.state = {
			productId: 0,
			description: '',
			productName: '',
			productImages: [],
			paymentConditions: [{ points: 0, price: 0 }]
		}
	}

	componentDidMount() {
		const { user, client, getPointsInformation, match } = this.props
		const { id } = match.params
		StoreProductService.getDetails(id).then(({ data }) => {
			const { description, name, paymentConditions, productImages } = data
			const images = productImages.map(({ source }) => {
				const imageUrl = `${baseUrl}${source}`
				return { original: imageUrl, thumbnail: imageUrl }
			})

			this.setState({
				description,
				productImages: images,
				productName: name,
				paymentConditions,
				productId: data.id
			})
		})

		var authenticated = user !== null
		if (authenticated && !client.clientPointsWasLoaded) getPointsInformation()
	}

	render() {
		const { client, user } = this.props
		const { productName, paymentConditions, productId } = this.state

		return (
			<Container>
				<StyledFlexContainer alignItems={'baseline'}>
					<Gallery className={'col-4'} items={this.state.productImages} />
					<PaymentInfo
						user={user}
						client={client}
						className={'col-8'}
						productId={productId}
						productName={productName}
						paymentConditions={paymentConditions}
					/>
				</StyledFlexContainer>
				<AccordionSecondary
					noAnimated
					noClickable
					arrow={false}
					multiple={false}
					items={this.getAccordionItems()}
				/>
			</Container>
		)
	}
}

function goToPointsExchange() {
	const { history, user } = this.props
	const isAuthenticated = user !== null
	history.push(`${isAuthenticated ? '/cliente' : ''}/loja-muviflex`)
}

function getAccordionItems() {
	return [
		{
			title: 'Descrição',
			content: (
				<div>
					<StyledDescription>{this.state.description}</StyledDescription>
					<StyledButtonContainer>
						<Button
							secondary
							type={'button'}
							onClick={this.goToPointsExchange}>
							Veja mais ofertas
						</Button>
					</StyledButtonContainer>
				</div>
			)
		}
	]
}

const mapStateToProps = ({ user, client }) => ({ user, client })

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			getPointsInformation: clientActions.getPointsInformation
		},
		dispatch
	)

const connectedStoreProductDetailPage = withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(StoreProductDetailPage)
)

export { connectedStoreProductDetailPage as ModuleRootComponent }
